import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/common-services/http-request.service';

import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http : HttpRequestService) { }
  bigChart() {
    return [ {
      name: 'Log Out Users',
      data: [502, 635,450 ,250,210],
      type:'column'
    },{
      name: 'Active Users',
      data: [106, 107,430 ,230,2711],
      type:'column'
    },
    {
      name: 'Active Users',
      data: [106, 107,430 ,230,2711],
      type:'column'
    }];
  }

  cards() {
    return [71, 78, 39, 66];
  }

 

  // pieChart() {
  //   return [{
  //     name: 'Active Users',
  //     y: 61.41,
  //     sliced: true,
  //     selected: true
  //   }, {
  //     name: 'Logout',
  //     y: 11.84
  //   },];
  // }
  pieChart() {
    return [{
      name: 'Chrome',
      y: 61.41,
      sliced: true,
      selected: true
    }, {
      name: 'Internet Explorer',
      y: 11.84
    }, {
      name: 'Firefox',
      y: 10.85
    }, {
      name: 'Edge',
      y: 4.67
    }, {
      name: 'Safari',
      y: 4.18
    }, {
      name: 'Sogou Explorer',
      y: 1.64
    }, {
      name: 'Opera',
      y: 1.6
    }, {
      name: 'QQ',
      y: 1.2
    }, {
      name: 'Other',
      y: 2.61
    }];
  }
}


